import {palette} from "../common";

export default {
	styleOverrides: {
		root: {
			backgroundColor: "white"
		}
	}
}
